import React, { useState } from 'react';
import { formatCurrency, generateId, translate } from '../../../../utility/functions';
import { BorderLessButton } from '../../../../forms/Button';
import Row from '../../../../layout/Row';
import Col from '../../../../layout/Col';

const RedeemedDrop = ({ label, quantity, breakdown, ...props }) => {
    const [dropped, setDropped] = useState(false);

    return (
        <>
            <td>
                <BorderLessButton
                    label={label}
                    onClick={() => setDropped(!dropped)}
                />
            </td>
            <td>
                <Col>
                    {
                        dropped ?
                            breakdown.map(h => h.map(i => (
                                <Row key={generateId()}>
                                    <span>{i.quantity} - {translate(i.discountType)} - {i.location}</span>
                                </Row>
                            )))
                        //discountTypes.filter()   
                        : quantity.reduce((a, e) => e += a)
                    }
                </Col>
            </td>
        </>
    );
}

export default RedeemedDrop;